import React from 'react';
import IndustryDetailPage from './IndustryDetailPage.jsx';

function TestimonialManufacturing() {
  return <IndustryDetailPage industry="manufacturing" />;
}

export default TestimonialManufacturing;
